
import { Card, CardContent } from "@/components/ui/card";
import { MapPin } from "lucide-react";
import { useTranslations } from "@/hooks/useTranslations";

interface TrainingLocationProps {
  gymPhotoUrl: string;
}

export const TrainingLocation = ({ gymPhotoUrl }: TrainingLocationProps) => {
  const { t } = useTranslations("publicProfile");
  
  if (!gymPhotoUrl) return null;
  
  return (
    <Card className="border-none shadow-lg bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm overflow-hidden">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <MapPin className="h-5 w-5 text-gray-700 dark:text-gray-300" />
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">{t("trainingLocation")}</h2>
        </div>
        <div className="overflow-hidden rounded-xl shadow-inner">
          <img 
            src={gymPhotoUrl} 
            alt="Local de treino"
            className="w-full rounded-xl object-cover h-[300px] hover:scale-105 transition-all duration-500 transform"
          />
        </div>
      </CardContent>
    </Card>
  );
};
